// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + "." + "e7876afafeafd63d0f92" + ".css";
};